var G_timer;
export function SpeakText(text) {
  clearInterval(G_timer);
  //   speechSynthesis.cancel();
      var msg = new SpeechSynthesisUtterance();
      var voices = window.speechSynthesis.getVoices();
      var Play = this;


      var voiceSelect = document.getElementById('voice');
      if (voiceSelect.value) {
          msg.voice = speechSynthesis.getVoices().filter(function(voice) { return voice.name == voiceSelect.value; })[0];
      }

      msg.text = text;
      console.log(this);
      msg.onend = function (e) {
          if(Play.state.playON)
          {
          //    console.log(this);
              G_timer = setInterval(()=>Play.process_next_word(true), Play.state.Verzug * 1000);
          }
      };
  
      speechSynthesis.speak(msg);

  }


export function SpeakText1111(text) {
  if(text=="")
  {
    return;
  }
    //var text =""
 //   speechSynthesis.cancel();
    var msg = new SpeechSynthesisUtterance();
    var voices = window.speechSynthesis.getVoices();
 //   msg.voice = voices[$('#voices').val()];
  //  msg.voice = voices[0];

    var voiceSelect = document.getElementById('voice');
	if (voiceSelect.value) {
		msg.voice = speechSynthesis.getVoices().filter(function(voice) { return voice.name == voiceSelect.value; })[0];
	}




    msg.text = text;
    msg.onend = function (e) {

      };
  
      speechSynthesis.speak(msg);

}

export function LoadSpeak()
{
    var voiceSelect = document.getElementById('voice');
var spanish;
var mexico="0";
    function loadVoices() {
        // Fetch the available voices.
          var voices = speechSynthesis.getVoices();
        
        // Loop through each of the voices.
          voices.forEach(function(voice, i) {
          // Create a new option element.
              var option = document.createElement('option');
          if(voice.name.toLowerCase().indexOf("spa") !== -1)
          {
            spanish = voice.name;
          }
          if(voice.name.toLowerCase().indexOf("mex") !== -1)
          {
            mexico = voice.name;
          }
        //   else if(voice.name.indexOf("Spa") !== -1){
        //     spanish = voice.name;
        //   }
          // Set the options value and text.
              option.value = voice.name;
              option.innerHTML = voice.name;
                {/* <MenuItem value={10}>Ten</MenuItem> */}
                
          // Add the option to the voice selector.
              voiceSelect.appendChild(option);
          });
      }
    if(mexico!="0")
    {
        alert("mex");
        spanish=mexico;
    }
        // Execute loadVoices.
      loadVoices();
      // Chrome loads voices asynchronously.
        window.speechSynthesis.onvoiceschanged = function(e) {
            loadVoices();
            if(mexico!="0")
            {
                spanish=mexico;
            }
            document.getElementById('voice').value=spanish;
        };
        if(mexico!="0")
        {
            spanish=mexico;
        }
        document.getElementById('voice').value=spanish;
}

//export var G_timer = false;

document.addEventListener("DOMContentLoaded", function(event) { 
var G_timer;
var G_slide_show = false;
 function SlideShow() {
  var text = document.getElementById("slide_show").text();
  if (text != "Stop") {
   //   G_timer = setInterval(process_next_word, 3000);
      G_timer = setInterval(function () { SpeakText("Hola"); }, 3000);
      document.getElementById("slide_show").text("Stop");
      G_slide_show = true;
  }
  else {
      clearInterval(G_timer);
      document.getElementById("slide_show").text("Slide show");
      G_slide_show = false;
  }
}

});